import { Controller } from "@tingwu/core";
import React, { memo } from "react";
import { useConnectStateWithController } from "../../model";

export interface ConnectControllerProps {
  controller: Controller;
}

export const ConnectController: React.FC<ConnectControllerProps> = memo(props => {
  const { controller } = props;
  useConnectStateWithController(controller);
  return null;
});
